module.exports = "../dist/frontend/images/gold/carousel/travel/travel-01.svg?b894cb64cfd1f069ed1bcd3b0043352b";